export default __webpack_public_path__ + "static/media/mens-top.c9d9aec8.png";